import { Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React, { useEffect } from "react";
import { Link, Route, Switch, useRouteMatch } from "react-router-dom";
import AC from "../img/AC.png";
import Answerfilteredout from "../img/Answerfilteredout.png";
import Answerstabimg from "../img/Answerstabimg.png";
import AssessmentNG from "../img/AssessmentNG.png";
import Autosave from "../img/Autosave.png";
import Averageandanalysistab from "../img/Averageandanalysistab.png";
import Caneditinfo from "../img/Caneditinfo.png";
import Charactermatching from "../img/Charactermatching.png";
import Clickfilters from "../img/Clickfilters.png";
import Clicktomark from "../img/Clicktomark.png";
import Choosetypeofresult from "../img/Choosetypeofresult.png";
import ColorCoding from "../img/ColorCoding.png";
import Editresultinfo from "../img/Editresultinfo.png";
import Expandall from "../img/Expandall.png";
import ExpandedBreakdown from "../img/ExpandedBreakdown.png";
import Expandstudent from "../img/Expandstudent.png";
import Filterboth from "../img/Filterboth.png";
import Filtercorrect from "../img/Filtercorrect.png";
import Filterhighconfidence from "../img/Filterhighconfidence.png";
import Filtersfiltered from "../img/Filtersfiltered.png";
import Filterstool from "../img/Filterstool.png";
import FinalScore from "../img/FinalScore.png";
import FlaggedasNG from "../img/FlaggedasNG.png";
import HoverAC from "../img/HoverAC.png";
import Hovernumbercolumn from "../img/Hovernumbercolumn.png";
import key from "../img/key.png";
import Listofacceptableanswers from "../img/Listofacceptableanswers.png";
import Manuallychangemarksimg from "../img/Manuallychangemarksimg.png";
import Markbreakdown from "../img/Markbreakdown.png";
import Markbreakdownarrow from "../img/Markbreakdownarrow.png";
import Needsgradingflag from "../img/Needsgradingflag.png";
import Needsgradingflag2 from "../img/Needsgradingflag2.png";
import NoSendicon from "../img/NoSendicon.png";
import RemoveNGforstudent from "../img/RemoveNGforstudent.png";
import Replacemanualgrading from "../img/Replacemanualgrading.png";
import Resultinfo from "../img/Resultinfo.png";
import resultssituations from "../img/resultssituations.svg";
import SaveandRM from "../img/SaveandRM.png";
import Selectall from "../img/Selectall.png";
import Sendresultpopup from "../img/Sendresultpopup.png";
import Sendresults from "../img/Sendresults.png";
import Sendresults1 from "../img/Sendresults1.png";
import Showacceptablearrow from "../img/Showacceptablearrow.png";
import SortingAnswers from "../img/SortingAnswers.png";
import SortingFlagged from "../img/SortingFlagged.png";
import SortingProblem1 from "../img/SortingProblem1.png";
import SortingProblem2 from "../img/SortingProblem2.png";
import Sortingresults from "../img/Sortingresults.png";
import Tolerance from "../img/Tolerance.png";
import Viewlargerimage from "../img/Viewlargerimage.png";

const useStyles = makeStyles((theme) => ({
  topicMain: {},
  root: {
    minHeight: "50vh",
    marginTop: "70px",
    paddingBottom: "50px",
    width: "100%",
    maxWidth: "800px",

    "& a": {
      color: "#4381b5",
    },
    "& h2": {
      marginBottom: "30px",
    },
    "& h4": {
      margin: "30px 0px",
    },
    "& img": {
      boxShadow: "0 3px 10px rgb(0 0 0 / 0.4)",
      borderRadius: "4px",

      // transition: "transform .2s",
      // "&:hover": {
      //   transform: "scale(1.3)",
      // },
    },
    "& ul": { marginLeft: "20px" },
    "& li": {
      marginLeft: "20px",
    },
  },
  imgSize: {
    maxWidth: "350px",
    width: "90%",
    display: "block",
    margin: "20px auto",
    marginBottom: "40px",
  },
  imgSize2: {
    maxWidth: "370px",
    width: "90%",
    margin: "20px auto",
    display: "block",
    marginTop: "20px",
  },
  imgSize3: {
    maxWidth: "300px",
    width: "80%",
    margin: "15px 20px 20px 20px",
    display: "block",
  },
  hyperlink: {
    textDecoration: "none",
    color: "#8277FF !important",
  },
  fontHeading: {
    marginBottom: "40px",
    fontSize: "28px",
    [theme.breakpoints.down("xs")]: {
      fontSize: "22px",
    },
  },
  highlighted: {
    backgroundColor: "#d8d2e7",
    width: "max-content",
    borderLeft: "5px solid #d8d2e7",
    borderRight: "5px solid #d8d2e7",
  },
}));

function WalkthroughVideo() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div>
        <Typography variant="h5" className={classes.fontHeading}>
          Tutorial video - Viewing and sending results
        </Typography>
      </div>
      <div display="block">
        <Typography className={classes.details} variant="body2"></Typography>
        <div
          class="wistia_responsive_padding"
          style={{
            padding: "56.25% 0 0 0",
            position: "relative",
            boxShadow: "0 3px 10px rgb(0 0 0 / 0.2)",
            borderRadius: "4px",
            marginBottom: "30px",
            marginTop: "30px",
          }}
        >
          <div
            class="wistia_responsive_wrapper"
            style={{
              height: "100%",
              left: "0",
              position: "absolute",
              top: "0",
              width: "100%",
            }}
          >
            <div
              class="wistia_embed wistia_async_khjqtsiccn videoFoam=true"
              style={{ height: "100%", position: "relative", width: "100%" }}
            >
              <div
                class="wistia_swatch"
                style={{
                  height: "100%",
                  left: "0",
                  opacity: "0",
                  overflow: "hidden",
                  position: "absolute",
                  top: "0",
                  transition: "opacity 200ms",
                  width: "100%",
                }}
              >
                <img
                  src="https://fast.wistia.com/embed/medias/khjqtsiccn/swatch"
                  style={{
                    filter: "blur(5px)",
                    height: "100%",
                    objectFit: "contain",
                    width: "100%",
                  }}
                  alt=""
                  aria-hidden="true"
                  onload="this.parentNode.style.opacity=1;"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function TipsandTricksResults() {
  const classes = useStyles();
  //   Needs Editing images
  return (
    <div className={classes.root}>
      <div>
        <Typography variant="h5" className={classes.fontHeading}>
          Results page - Tips and Tricks{" "}
        </Typography>
        <Typography
          variant="body2"
          style={{ marginTop: "-20px", marginBottom: "40px" }}
        >
          Our results section is not just about seeing your student’s final
          scores. Instead, it has a ton of really powerful features to make your
          life easier, as seen below:
        </Typography>
      </div>
      <div display="block">
        <Typography className={classes.details} variant="body2">
          <a href="#filters">Filter results</a>
          <br />
          <br />
          <a href="#needsgradingtip">‘Needs grading’ flags</a>
          <br />
          <br />
          <a href="#answerstabtips">The Answers tab</a>
          <br />
          <br />
          <a href="#viewallresults">View all results at once</a>
          <br />
          <br />
          <a href="#shortcutmanually">Shortcut for manually changing marks</a>
          <br />
          <br />
          <a href="#enlargeimage">Enlarge an image of a student’s answer</a>
          <br />
          <br />
          <a href="#sendresultstips">Sending results to students</a>
          <br />
          <br />
          <a href="#autoremark">Automatically re-mark results</a>
          <br />
          <br />
          <a href="#averagesandanalysis">The Averages and Analysis tabs</a>
          <br />
          <br />
          <a href="#displayanstype">Display answer type</a>
          <br />
          <br />
          <a href="#sortingtips">Sorting</a>
          <br />
          <br />
        </Typography>
        <Typography className={classes.highlighted} variant="h6" id="filters">
          Filter results:
        </Typography>
        <ul>
          <Typography className={classes.details} variant="body2">
            We have a filters tool that allows you to focus only on what's
            important to you.
            <br />
            <br />
            For answer sheets with student handwriting, set up our filters tool
            like below see which answers need manual grading:
          </Typography>
          <img
            style={{ maxWidth: "400px" }}
            className={classes.imgSize3}
            src={Filterhighconfidence}
            alt="Filter confidence"
          />
          <Typography className={classes.details} variant="body2">
            To see which answers students struggled with, try unselecting the
            'Correct' answers:
          </Typography>
          <img
            style={{ maxWidth: "400px" }}
            className={classes.imgSize3}
            src={Filtercorrect}
            alt="Filter"
          />
          <Typography className={classes.details} variant="body2">
            Note that often you can combine the above two to limit the amount of
            material you are looking at:
          </Typography>
          <img
            style={{ maxWidth: "400px" }}
            className={classes.imgSize3}
            src={Filterboth}
            alt="Filter both"
          />
          <Typography
            className={classes.highlighted}
            variant="h6"
            id="needsgradingtip"
          >
            'Needs grading' flags:
          </Typography>
          <Typography
            displau="block"
            className={classes.details}
            variant="body2"
          >
            <Link
              to="/help-topics/view-and-send/answers-flagged"
              className={classes.hyperlink}
            >
              'Needs grading'
            </Link>{" "}
            means that SwiftGrade is unsure about a student’s handwritten
            answer, and thus you need to manually check it.
            <br />
            <br />
            If an answer was flagged for needs grading, you will see a Hand icon
            next to it:
          </Typography>
          <img
            style={{ maxWidth: "800px" }}
            className={classes.imgSize}
            src={FlaggedasNG}
            alt="Flagged"
          />
          <Typography
            className={classes.highlighted}
            variant="h6"
            id="answerstabtips"
          >
            The Answers tab:
          </Typography>
          <Typography
            display="block"
            className={classes.details}
            variant="body2"
          >
            Often when teachers grade, they will grade one page at a time.
            Similarly, you can use the answers tab to grade one answer at a
            time. See a screenshot of the{" "}
            <Link
              to="/help-topics/view-and-send/the-answers-tab"
              className={classes.hyperlink}
            >
              'Answers tab'
            </Link>{" "}
            below:
          </Typography>
          <img
            style={{ maxWidth: "800px" }}
            className={classes.imgSize}
            src={Answerstabimg}
            alt="Filter"
          />
          <Typography
            className={classes.highlighted}
            variant="h6"
            id="viewallresults"
          >
            View all results at once:
          </Typography>
          <Typography
            displau="block"
            className={classes.details}
            variant="body2"
          >
            If you click this button, the answers of all students will expand at
            once.
            <br />
            <br />
            This means that you can view all results on one page instead of
            having to click on each student one by one.
          </Typography>
          <img
            style={{ maxWidth: "800px" }}
            className={classes.imgSize}
            src={Expandall}
            alt="Expand all"
          />
          <Typography
            className={classes.highlighted}
            variant="h6"
            id="shortcutmanually"
          >
            Shortcut for manually changing marks:
          </Typography>
          <Typography
            displau="block"
            className={classes.details}
            variant="body2"
          >
            Instead of typing to change marks, you can click the total score to
            give either zero or full marks:
          </Typography>
          <img
            style={{ maxWidth: "800px" }}
            className={classes.imgSize}
            src={Clicktomark}
            alt="Click to mark"
          />
          <Typography
            className={classes.highlighted}
            variant="h6"
            id="enlargeimage"
          >
            Enlarge an image of a student’s answer:
          </Typography>
          <Typography
            displau="block"
            className={classes.details}
            variant="body2"
          >
            To enlarge a student’s answer, right-click on the image, and then
            either save it, or open it in a new tab:
          </Typography>
          <img
            style={{ maxWidth: "800px" }}
            className={classes.imgSize}
            src={Viewlargerimage}
            alt="View larger"
          />
          <Typography
            className={classes.highlighted}
            variant="h6"
            id="sendresultstips"
          >
            Send results to students:
          </Typography>
          <Typography className={classes.details} variant="body2">
            To send student's their results, click 'more options' and then send:
          </Typography>
          <img
            style={{ maxWidth: "800px" }}
            className={classes.imgSize}
            src={Sendresults}
            alt="No send icon"
          />
          <Typography className={classes.details} variant="body2">
            Note that students without an email address won't be able to receive
            results.
          </Typography>
          <Typography
            className={classes.highlighted}
            variant="h6"
            id="autoremark"
          >
            Automatically re-mark results
          </Typography>

          <Typography
            displau="block"
            className={classes.details}
            variant="body2"
          >
            If you notice there was an error in your answer key, or simply want
            to update your answers, you don’t need to manually re-mark each
            student.
            <br />
            <br />
            Instead, simply edit your answer key and all students will be
            re-marked against the new key.
            <br />
            <br />
            To re-mark results, go to the Assessments page, click more options,
            and then Edit:
          </Typography>
          <img
            style={{ maxWidth: "800px" }}
            className={classes.imgSize}
            src={key}
            alt="Key"
          />
          <Typography
            displau="block"
            className={classes.details}
            variant="body2"
          >
            From here, make changes to your answer key and when done click ‘Save
            and Re-mark’.
          </Typography>

          <Typography
            className={classes.highlighted}
            variant="h6"
            id="averagesandanalysis"
          >
            The Averages and Analysis tab:
          </Typography>
          <Typography className={classes.details} variant="body2">
            Check out the Averages and{" "}
            <Link
              className={classes.hyperlink}
              to="/help-topics/view-and-send/analysis-tab"
            >
              Analysis tab{" "}
            </Link>{" "}
            to see an overview of how your class performed. For example, you can
            see which questions students struggled the most with, or what were
            the most common answers.
          </Typography>

          <img
            style={{ maxWidth: "800px" }}
            className={classes.imgSize}
            src={Averageandanalysistab}
            alt="Average and analysis tab"
          />

          <Typography
            className={classes.highlighted}
            variant="h6"
            id="displayanstype"
          >
            Display the answer type for each answer:
          </Typography>
          <Typography
            displau="block"
            className={classes.details}
            variant="body2"
          >
            To display the answer type, hover on the # column:
          </Typography>

          <img
            style={{ maxWidth: "800px" }}
            className={classes.imgSize}
            src={Hovernumbercolumn}
            alt="Hover"
          />
          <Typography
            className={classes.highlighted}
            variant="h6"
            id="sortingtips"
          >
            Sorting:
          </Typography>
          <Typography
            displau="block"
            className={classes.details}
            variant="body2"
          >
            For easy input into your gradebook, you can sort by a student's
            first name, last name or score by clicking the column headers:
          </Typography>
          <img
            style={{ maxWidth: "800px" }}
            className={classes.imgSize}
            src={Sortingresults}
            alt="Sorting"
          />
        </ul>
      </div>
    </div>
  );
}

function ResultsTab() {
  const classes = useStyles();
  return (
    <div className={classes.root} style={{ maxWidth: "900px" }}>
      <div>
        <Typography variant="h5" className={classes.fontHeading}>
          Results tab
        </Typography>
      </div>
      <div display="block">
        <Typography className={classes.details} variant="body2">
          <a href="#theresultstab">The results tab</a>
          <br />
          <br />
          <a href="#resultstabtips">Results tab tips</a>
          <br />
          <br />
        </Typography>
        <Typography
          className={classes.highlighted}
          variant="h6"
          id="theresultstab"
        >
          The results tab:
        </Typography>

        <Typography className={classes.details} variant="body2">
          The results tab is where you can view results by student.
          <br />
          <br />
          While collapsed, you can see a snapshot of each student’s final score:
          <br />
          <br />
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={FinalScore}
          alt="Final Score"
        />
        <Typography className={classes.details} variant="body2">
          When you click expand:
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={Expandstudent}
          alt="Expand student"
        />
        <Typography className={classes.details} variant="body2">
          You can now view students’ answer sheet breakdowns:
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={ExpandedBreakdown}
          alt="Expanded breakdown"
        />
        <Typography
          className={classes.highlighted}
          variant="h6"
          id="resultstabtips"
        >
          Results tab tips:
        </Typography>
        <ul>
          <li>
            <Typography className={classes.details} variant="body2">
              To view a larger version of a student’s answer, right click on the
              image, and then either save it, or open it in a new tab:
            </Typography>
          </li>
          <img
            style={{ maxWidth: "800px" }}
            className={classes.imgSize}
            src={Viewlargerimage}
            alt="View larger"
          />
          <li>
            <Typography className={classes.details} variant="body2">
              You can sort by a student's first name, last name, or score by
              clicking the column headers:
            </Typography>
          </li>
          <img
            style={{ maxWidth: "800px" }}
            className={classes.imgSize}
            src={Sortingresults}
            alt="Sorting"
          />
          <li>
            <Typography className={classes.details} variant="body2">
              To display the answer type hover on the # column:
            </Typography>
          </li>
          <img
            style={{ maxWidth: "800px" }}
            className={classes.imgSize}
            src={Hovernumbercolumn}
            alt="Hover"
          />
        </ul>
      </div>
    </div>
  );
}
function AnswersTab() {
  const classes = useStyles();
  return (
    <div className={classes.root} style={{ maxWidth: "900px" }}>
      <div>
        <Typography variant="h5" className={classes.fontHeading}>
          Answers tab
        </Typography>
      </div>
      <div display="block">
        <Typography className={classes.details} variant="body2">
          The answers tab is where you can view all student responses for a
          particular answer.
          <br />
          <br />
          For example, the image below shows how every student responded to
          answer #1. You can go to other answers by using the answer number drop
          down or clicking on next/previous:
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={Answerstabimg}
          alt="Answers tab"
        />
        <Typography className={classes.details} variant="body2">
          You can sort by a student's first name, last name, or score by
          clicking the column headers:
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={SortingAnswers}
          alt="Sorting"
        />
      </div>
    </div>
  );
}

function ManuallyChangeMarks() {
  const classes = useStyles();
  return (
    <div className={classes.root} style={{ maxWidth: "900px" }}>
      <div>
        <Typography variant="h5" className={classes.fontHeading}>
          Manually change student marks
        </Typography>
      </div>
      <div display="block">
        <Typography className={classes.details} variant="body2">
          <a href="#manuallychange">Manually change student marks</a>
          <br />
          <br />
          <a href="#additionalinfo">Additional info</a>
          <br />
          <br />
        </Typography>
        <Typography
          className={classes.highlighted}
          variant="h6"
          id="manuallychange"
        >
          Manually change student marks:
        </Typography>
        <Typography className={classes.details} variant="body2">
          You can manually change student marks from either the{" "}
          <Link
            className={classes.hyperlink}
            to="/help-topics/view-and-send/the-results-tab"
          >
            Results tab
          </Link>{" "}
          or the{" "}
          <Link
            className={classes.hyperlink}
            to="/help-topics/view-and-send/the-answers-tab"
          >
            Answers tab.
          </Link>{" "}
          <br />
          <br />
          To change a mark, click into the marks field and type a new mark:
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={Manuallychangemarksimg}
          alt="Change marks"
        />
        <Typography className={classes.details} variant="body2">
          If you type a mark greater than the max value for that answer, it will
          auto-change to the max value.
          <br />
          <br />
          As a shortcut to typing, click the total score to either give full or
          zero marks:
        </Typography>
        <img
          style={{ maxWidth: "600px" }}
          className={classes.imgSize3}
          src={Clicktomark}
          alt="Click to mark"
        />

        <Typography
          className={classes.highlighted}
          variant="h6"
          id="additionalinfo"
        >
          Additional info:
        </Typography>

        <Typography
          style={{ fontWeight: "700" }}
          className={classes.details}
          variant="body2"
        >
          Auto-save:
        </Typography>
        <Typography className={classes.details} variant="body2">
          There is no save button - updated marks will auto-save:
        </Typography>

        <img
          style={{ maxWidth: "400px" }}
          className={classes.imgSize3}
          src={Autosave}
          alt="Auto save"
        />

        <Typography className={classes.details} variant="body2">
          <span style={{ fontWeight: "700" }}>Needs grading flag:</span> If an
          answer was flagged as{" "}
          <Link
            to="/help-topics/view-and-send/answers-flagged"
            className={classes.hyperlink}
          >
            ‘Needs manual grading’{" "}
          </Link>
          , as soon as you change its mark, the flag will automatically be
          removed:
        </Typography>

        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={Needsgradingflag}
          alt="Needs grading"
        />
      </div>
    </div>
  );
}
function FlaggedNeedsGrading() {
  const classes = useStyles();
  return (
    <div className={classes.root} style={{ maxWidth: "900px" }}>
      <div>
        <Typography variant="h5" className={classes.fontHeading}>
          Answers flagged as ‘Needs grading’
        </Typography>
      </div>
      <div display="block">
        <Typography className={classes.details} variant="body2">
          <a href="#whatisneedsgrading">What is ‘Needs grading’?</a>
          <br />
          <br />
          <a href="#removingneedsgrading">Removing ‘Needs grading’</a>
          <br />
          <br />
        </Typography>
        <Typography
          className={classes.highlighted}
          variant="h6"
          id="whatisneedsgrading"
        >
          What is ‘Needs grading’?
        </Typography>
        <Typography className={classes.details} variant="body2">
          ‘Needs grading’ means that SwiftGrade is not confident that it read a
          student’s handwritten answer correctly, and thus you need to manually
          grade it.
          <br />
          <br />
          The ‘Needs grading’ flag can only appear for written answer sheets
          because they are the only ones with student handwriting. Multiple
          choice and online assessments cannot have a ‘Needs grading flag’.
          <br />
          <br />
          The ‘Needs grading’ flag can be on both the{" "}
          <Link
            className={classes.hyperlink}
            to="/help-topics/view-and-send/the-results-tab"
          >
            Results tab
          </Link>{" "}
          and the{" "}
          <Link
            className={classes.hyperlink}
            to="/help-topics/view-and-send/the-answers-tab"
          >
            Answers tab
          </Link>{" "}
          <br />
          <br />
          If an an answer was flagged for needs grading, you will see a Hand
          icon next to it:
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={FlaggedasNG}
          alt="Flagged as NG"
        />
        <Typography
          className={classes.highlighted}
          variant="h6"
          id="removingneedsgrading"
        >
          Removing the ‘Needs grading’ flag
        </Typography>

        <Typography className={classes.details} variant="body2">
          You do not need to remove the ‘Needs grading’ flag. However, if you
          want, you can remove it by simply clicking the icon:
          <br />
          <br />
          The ‘Needs grading’ flag will also be manually removed if you manually
          change the grade - since this means you have manually checked and
          marked the answer:
        </Typography>

        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={Needsgradingflag2}
          alt="Needs grading"
        />
        <Typography className={classes.details} variant="body2">
          If a student has at least one answer flagged as ‘Needs grading’, then
          ‘Needs grading’ will be written next to their final score. If you
          click this, all ‘Needs grading’ for that student will be removed.
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={RemoveNGforstudent}
          alt="Remove Needs Grading"
        />
        <Typography className={classes.details} variant="body2">
          Similarly, on the assessments page, if at least one student has at
          least one answer flagged as ‘Needs grading’, then ‘Needs grading’ will
          be written next to the assessment. Once again, if you click ‘Needs
          grading’, all ‘Needs grading’ flags for all students will be removed.
        </Typography>
      </div>
      <img
        style={{ maxWidth: "800px" }}
        className={classes.imgSize}
        src={AssessmentNG}
        alt="Assessment Needs Grading"
      />
    </div>
  );
}
function FilteringStudentResults() {
  const classes = useStyles();
  return (
    <div className={classes.root} style={{ maxWidth: "900px" }}>
      <div>
        <Typography variant="h5" className={classes.fontHeading}>
          Filtering student results{" "}
        </Typography>
      </div>
      <div display="block">
        <Typography className={classes.details} variant="body2">
          <a href="#accessingfilters">Accessing the filters tool</a>
          <br />
          <br />
          <a href="#moreinfofilters">More info on the filters tool</a>
          <br />
          <br />
          <a href="#tipsforfilters">Tips for using filters</a>
          <br />
          <br />
        </Typography>
        <Typography
          className={classes.highlighted}
          variant="h6"
          id="accessingfilters"
        >
          Accessing the filters tool:
        </Typography>
        <Typography className={classes.details} variant="body2">
          On both the{" "}
          <Link
            className={classes.hyperlink}
            to="/help-topics/view-and-send/the-results-tab"
          >
            Results tab
          </Link>{" "}
          and the{" "}
          <Link
            className={classes.hyperlink}
            to="/help-topics/view-and-send/the-answers-tab"
          >
            Answers tab
          </Link>{" "}
          there is a filters tool that allows you to view only the results that
          you want.
          <br />
          <br />
          To access the tool, click the Filters icon:
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={Clickfilters}
          alt="Click filters"
        />
        <Typography className={classes.details} variant="body2">
          And then deselect which answer types you want to hide.
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={Filterstool}
          alt="Filters tool"
        />
        <Typography
          className={classes.highlighted}
          variant="h6"
          id="moreinfofilters"
        >
          More info on the filters tool:
        </Typography>
        <ul>
          <li>
            <Typography className={classes.details} variant="body2">
              The last two filter items will not be shown for Multiple choice
              and Online assessments:
            </Typography>
          </li>
          <img
            style={{ maxWidth: "800px" }}
            className={classes.imgSize}
            src={Filtersfiltered}
            alt="Filters filtered"
          />
          <Typography className={classes.details} variant="body2">
            The reason for this is because there is no handwriting to have high
            or low confidence for.
            <br />
            <br />
            <br />
          </Typography>
          <li>
            <Typography className={classes.details} variant="body2">
              If you are on the Results tab and all of a student’s answers get
              filtered out, that student will be removed.
              <br />
              <br />
              Similarly, on the answers tab, an entire answer # can be filtered
              out.
              <br />
              <br />
              For example, here you can see all answers except #1, 3 and 7 have
              been filtered out of the answers tab:
            </Typography>

            <img
              style={{ maxWidth: "800px" }}
              className={classes.imgSize}
              src={Answerfilteredout}
              alt="Filtered out"
            />
          </li>
        </ul>
        <Typography
          className={classes.highlighted}
          variant="h6"
          id="tipsforfilters"
        >
          Tips when using filters:
        </Typography>

        <Typography className={classes.details} variant="body2">
          Here are two common ways that teachers use the Filters tool:
          <br />
          <br />
          <span
            style={{ fontWeight: "700" }}
            className={classes.details}
            variant="body2"
          >
            Filter to view answers that Need manual grading:
          </span>
          <br />
          <br />
          For written answer sheets with student handwriting, use filters to be
          able to easily see which answers are flagged as low confidence, and
          thus need manual grading.
          <br />
          <br />
          To view all answers that need manual grading, please set up the
          filters tool like this:
        </Typography>

        <img
          style={{ maxWidth: "400px" }}
          className={classes.imgSize3}
          src={Filterhighconfidence}
          alt="Filter high confidence"
        />
        <Typography
          style={{ fontWeight: "700" }}
          className={classes.details}
          variant="body2"
        >
          View answers that students struggled with:
          <br />
          <br />
        </Typography>

        <Typography className={classes.details} variant="body2">
          By filtering out the correct answers, you can quickly see what
          students struggled with:
        </Typography>
        <img
          style={{ maxWidth: "400px" }}
          className={classes.imgSize3}
          src={Filtercorrect}
          alt="Filter correct"
        />
        <Typography className={classes.details} variant="body2">
          Note that often you can combine the above two, to limit the amount of
          material you are looking at, while still getting a good idea of where
          your class is at:
        </Typography>
        <img
          style={{ maxWidth: "400px" }}
          className={classes.imgSize3}
          src={Filterboth}
          alt="Filter correct"
        />
      </div>
    </div>
  );
}
function FeaturesSuchAs() {
  const classes = useStyles();
  return (
    <div className={classes.root} style={{ maxWidth: "900px" }}>
      <div className={classes.accordionSummary}>
        <Typography variant="h5" className={classes.fontHeading}>
          Results page features{" "}
        </Typography>
      </div>
      <Typography className={classes.details} variant="body2">
        The following features can be seen on both the{" "}
        <Link
          className={classes.hyperlink}
          to="/help-topics/view-and-send/the-results-tab"
        >
          Results tab
        </Link>{" "}
        and the{" "}
        <Link
          className={classes.hyperlink}
          to="/help-topics/view-and-send/the-answers-tab"
        >
          Answers tab.
        </Link>{" "}
        <br />
        <br />
      </Typography>
      <div display="block">
        <Typography className={classes.details} variant="body2">
          <a href="#multipleacceptable">Multiple acceptable answers</a>
          <br />
          <br />
          <a href="#markbreakdown">Mark breakdown (U or SF was on)</a>
          <br />
          <br />
          <a href="#autocorrectac">Auto-Correct (AC)</a>
          <br />
          <br />
          <a href="#tolerance">Tolerance</a>
          <br />
          <br />
          <a href="#enlargestudentans">Enlarge student answer</a>
          <br />
          <br />
          <a href="#colorcoding">Color coding</a>
          <br />
          <br />
          <a href="#onlycharmatching">Grade only by character matching</a>
          <br />
          <br />
        </Typography>
        <Typography
          className={classes.highlighted}
          variant="h6"
          id="multipleacceptable"
        >
          Multiple acceptable answers:
        </Typography>
        <Typography className={classes.details} variant="body2">
          If you had specified more than one acceptable answer, then in the
          answer key column there will be a dropdown arrow:
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={Showacceptablearrow}
          alt="Show acceptable"
        />
        <Typography className={classes.details} variant="body2">
          Clicking this will show a list of all acceptable answers and their
          mark value.
          <br />
          <br />
          If the student's answer matched any of the acceptable answers, it will
          be highlighted:
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={Listofacceptableanswers}
          alt="List of acceptable"
        />
        <Typography
          className={classes.highlighted}
          variant="h6"
          id="markbreakdown"
        >
          Mark breakdown (U or SF was on):
        </Typography>

        <Typography className={classes.details} variant="body2">
          If the answer had Units or Sig figs on, then there will be a drop down
          arrow in the marks column:
        </Typography>

        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={Markbreakdownarrow}
          alt="mark breakdown"
        />
        <Typography className={classes.details} variant="body2">
          Clicking this will expand the mark breakdown for this answer which
          shows how each part of the answer was graded:
        </Typography>

        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={Markbreakdown}
          alt="mark breakdown"
        />

        <Grid container justifyContent="space-around">
          <Typography className={classes.details} variant="body2">
            <span style={{ fontWeight: "700" }}>A</span> = Marks for the answer
          </Typography>
          <Typography className={classes.details} variant="body2">
            <span style={{ fontWeight: "700" }}>U</span> = Marks for Units
          </Typography>
          <Typography className={classes.details} variant="body2">
            <span style={{ fontWeight: "700" }}>SF</span> = Marks for Sig Figs
          </Typography>
        </Grid>
        <Typography
          className={classes.highlighted}
          variant="h6"
          id="autocorrectac"
        >
          Auto-correct (AC):{" "}
        </Typography>

        <Typography className={classes.details} variant="body2">
          For fill in the blank answers, if the AC toggle was on and the
          student’s answer was actually auto-corrected, there will be an AC icon
          shown:
        </Typography>

        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={AC}
          alt="Auto correct"
        />

        <Typography className={classes.details} variant="body2">
          If you hover on this icon, it will tell you how the student’s answer
          was auto corrected:
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={HoverAC}
          alt="Hover AC"
        />
        <Typography className={classes.highlighted} variant="h6" id="tolerance">
          Tolerance:
        </Typography>

        <Typography className={classes.details} variant="body2">
          If you set a tolerance, it can be seen in the answer key column:
        </Typography>

        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={Tolerance}
          alt="Tolerance"
        />

        <Typography className={classes.details} variant="body2">
          When tolerance is on, a student's answer doesn’t have to exactly match
          your answer. Instead, as long as they are within your tolerance range
          they could still be marked correct.
        </Typography>
        <Typography
          className={classes.highlighted}
          variant="h6"
          id="enlargestudentans"
        >
          Enlarge student image:
        </Typography>

        <Typography className={classes.details} variant="body2">
          To view a larger version of a student’s answer, right click on the
          image, and then either save it, or open it in a new tab:
        </Typography>

        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={Viewlargerimage}
          alt="View larger"
        />
        <Typography
          className={classes.highlighted}
          variant="h6"
          id="colorcoding"
        >
          Color coding:
        </Typography>

        <Typography className={classes.details} variant="body2">
          The results page is colour coded for your convenience.
          <br />
          <br />
        </Typography>

        <Grid container justifyContent="space-around">
          <Typography className={classes.details} variant="body2">
            <span style={{ fontWeight: "700", color: "green" }}>Green</span> =
            Full marks
          </Typography>
          <Typography className={classes.details} variant="body2">
            <span style={{ fontWeight: "700", color: "#bf9000" }}>Yellow</span>{" "}
            = Partial marks
          </Typography>
          <Typography className={classes.details} variant="body2">
            <span style={{ fontWeight: "700", color: "red" }}>Red</span> = Zero
            marks
          </Typography>
          <br />
          <br />
        </Grid>

        <Typography className={classes.details} variant="body2">
          Both the student answer, as well as the marks column is color coded.
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={ColorCoding}
          alt="Color coding"
        />
        <Typography className={classes.details} variant="body2">
          For example for #3 above:
          <ul>
            <li>
              Student answer column:
              <span style={{ marginLeft: "20px" }}>
                Answer ={" "}
                <span style={{ fontWeight: "700", color: "green" }}>
                  correct
                </span>
              </span>
              <span style={{ marginLeft: "20px" }}>
                Units ={" "}
                <span style={{ fontWeight: "700", color: "red" }}>
                  incorrect
                </span>
              </span>
              <br />
              <br />
            </li>
            <li>
              Total mark column: 0.75/1 ={" "}
              <span style={{ fontWeight: "700", color: "#bf9000" }}>
                Partial Mark
              </span>
            </li>
          </ul>
        </Typography>
        <Typography
          className={classes.highlighted}
          variant="h6"
          id="onlycharmatching"
        >
          Grade only by character matching:
        </Typography>

        <Typography className={classes.details} variant="body2">
          If a math answer can only be graded using character matching, this
          icon will appear next to your answer:
          <br />
          <br />
        </Typography>

        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={Charactermatching}
          alt="character match"
        />
      </div>
    </div>
  );
}
function ViewEditResultsInfo() {
  const classes = useStyles();
  return (
    <div className={classes.root} style={{ maxWidth: "900px" }}>
      <div>
        <Typography variant="h5" className={classes.fontHeading}>
          View a student’s result info
        </Typography>
      </div>
      <div display="block">
        <Typography className={classes.details} variant="body2">
          If you want to view or edit a student’s result information, in the{" "}
          <Link
            className={classes.hyperlink}
            to="/help-topics/view-and-send/the-results-tab"
          >
            Results tab
          </Link>{" "}
          click on more options, then Info.
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={Resultinfo}
          alt="Result info"
        />
        <Typography className={classes.details} variant="body2">
          You can now see info such as name, email, date scanned (for paper
          assessments) and date submitted (for online assessments):
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={Editresultinfo}
          alt="Edit results info"
        />

        <Typography className={classes.details} variant="body2">
          If the student wrote their name and email into the answer sheet, you
          can edit that information.
        </Typography>
        <img
          style={{ maxWidth: "400px" }}
          className={classes.imgSize3}
          src={Caneditinfo}
          alt="Can edit"
        />
        <Typography className={classes.details} variant="body2">
          However, if it was a pre-filled answer sheet, or an online answer
          sheet where the student’s name and email was pre-filled, then this
          info can’t be changed:
        </Typography>
        <img
          style={{ maxWidth: "400px" }}
          className={classes.imgSize3}
          src={Caneditinfo}
          alt="Cant edit"
        />
      </div>
    </div>
  );
}

function SendResultstoStudents() {
  const classes = useStyles();
  return (
    <div className={classes.root} style={{ maxWidth: "900px" }}>
      <div>
        <Typography variant="h5" className={classes.fontHeading}>
          Send results to students
        </Typography>
      </div>
      <div display="block">
        <Typography className={classes.details} variant="body2">
          <a href="#sendresults">Send results</a>
          <br />
          <br />
          <a href="#additionalinfosend">Additional info</a>
          <br />
          <br />
        </Typography>
        <Typography
          className={classes.highlighted}
          variant="h6"
          id="sendresults"
        >
          Send results:
        </Typography>
        <Typography className={classes.details} variant="body2">
          You can send results to students from the{" "}
          <Link
            className={classes.hyperlink}
            to="/help-topics/view-and-send/the-results-tab"
          >
            Results tab
          </Link>{" "}
          in just a few clicks.
          <br />
          <br />
          To send results to a single student, select 'more options', then send:
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={Sendresults1}
          alt="Send results"
        />
        <Typography className={classes.details} variant="body2">
          Next, choose the type of result, click send again, and you're done:
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={Choosetypeofresult}
          alt="Send result popup"
        />
        <Typography className={classes.details} variant="body2">
          To send results to all students at once, select the top circle, and
          repeat the same steps:
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={Selectall}
          alt="Send result popup"
        />
        <Typography
          className={classes.highlighted}
          variant="h6"
          id="additionalinfosend"
        >
          Additional info:
        </Typography>

        <Typography className={classes.details} variant="body2">
          Note that you can only send results to students that have an email or
          username associated with their result:
          <br />
          <br />
        </Typography>

        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={NoSendicon}
          alt="No send"
        />
        <Typography className={classes.details} variant="body2">
          Here’s how students will receive their results in various situations:
          <br />
          <br />
        </Typography>

        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={resultssituations}
          alt="No send"
        />
      </div>
    </div>
  );
}
function RemarkingResults() {
  const classes = useStyles();
  return (
    <div className={classes.root} style={{ maxWidth: "900px" }}>
      <div>
        <Typography variant="h5" className={classes.fontHeading}>
          Re-mark results
        </Typography>
      </div>
      <div display="block">
        <Typography className={classes.details} variant="body2">
          <a href="#howtoremarks">How to Re-mark results</a>
          <br />
          <br />
          <a href="#additionalinforemark">Additional info:</a>
          <br />
          <br />
        </Typography>
        <Typography
          className={classes.highlighted}
          variant="h6"
          id="howtoremarks"
        >
          How to re-mark results:{" "}
        </Typography>
        <Typography className={classes.details} variant="body2">
          If you notice there was an error in your answer key, or simply want to
          update your answers, you don’t need to manually re-mark each student.
          <br />
          <br />
          Instead, simply edit your answer key and all students will be
          re-marked against the new key.
          <br />
          <br />
          To re-mark results, go to the Assessments page, click More options,
          then Edit:
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={key}
          alt="Key"
        />
        <Typography className={classes.details} variant="body2">
          From here, make changes to your answer key and when done click ‘Save
          and Re-mark’.
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={SaveandRM}
          alt="Save"
        />
        <Typography className={classes.details} variant="body2">
          As soon as you click ‘Save and Re-Mark’, student results will
          automatically be re-marked against this new key.
        </Typography>
        <Typography
          className={classes.highlighted}
          variant="h6"
          id="additionalinforemark"
        >
          Additional info:
        </Typography>
        <ul>
          <li>
            <Typography className={classes.details} variant="body2">
              If you notice in the image above, some functions on the Edit and
              Re-Mark page are dim and thus not allowed.
              <br />
              <br />
            </Typography>
          </li>
          <li>
            <Typography className={classes.details} variant="body2">
              For example, if answer #1 is multiple choice. Changing it to
              Numeric is not allowed because then your answer key won’t match
              the answer sheets that students responded in.
              <br />
              <br />
            </Typography>
          </li>

          <li>
            <Typography className={classes.details} variant="body2">
              If you had manually changed student marks in the results section,
              then you will get this pop up when you try to click ‘Save and
              Re-mark’:
              <br />
              <br />
            </Typography>
          </li>
        </ul>

        <img
          style={{ maxWidth: "500px" }}
          className={classes.imgSize3}
          src={Replacemanualgrading}
          alt="Replace manual grading"
        />
        <Typography className={classes.details} variant="body2">
          If you select the first option, all answers that you manually graded
          will not be re-marked. The grade you entered will remain.
          <br />
          <br />
          If you select the second option, all answers, including ones that you
          manually graded will be re-marked against the new answer key.
        </Typography>
      </div>
    </div>
  );
}

function AnalysisTab() {
  const classes = useStyles();
  return (
    <div className={classes.root} style={{ maxWidth: "900px" }}>
      <div>
        <Typography variant="h5" className={classes.fontHeading}>
          The Analysis tab
        </Typography>
      </div>
      <div display="block">
        <Typography className={classes.details} variant="body2">
          <a href="#whatisanalysis">What is the analysis tab</a>
          <br />
          <br />
          <a href="#sortinganalysis">Sorting</a>
          <br />
          <br />
          <a href="#problemquest">‘Problem question’ flags</a>
          <br />
          <br />
          <a href="#mostcommonans">Most common answers</a>
          <br />
          <br />
        </Typography>
        <Typography
          className={classes.highlighted}
          variant="h6"
          id="whatisanalysis"
        >
          What is the analysis tab:
        </Typography>
        <Typography className={classes.details} variant="body2">
          The analysis tab allows you to see a snapshot of how the whole class
          performed on each question and which questions students struggled the
          most with.
          <br />
          <br />
        </Typography>

        <Typography
          className={classes.highlighted}
          variant="h6"
          id="sortinganalysis"
        >
          Sorting:
        </Typography>
        <Typography className={classes.details} variant="body2">
          Sort by clicking on the column headers to view which questions
          students struggled the most with.
          <br />
          <br />
          The image below has been sorted by the least number of correct answers
          at the top:
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={SortingProblem1}
          alt="Sorting"
        />

        <Typography
          className={classes.highlighted}
          variant="h6"
          id="problemquest"
        >
          ‘Problem question’ flags:
        </Typography>
        <Typography className={classes.details} variant="body2">
          If less than 50% of students got a question correct there will be a
          ‘Problem question’ flag next to it:
        </Typography>

        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={SortingFlagged}
          alt="Sorting"
        />

        <Typography
          className={classes.highlighted}
          variant="h6"
          id="mostcommonans"
        >
          Most common answers:
        </Typography>
        <Typography className={classes.details} variant="body2">
          The column on the far right shows the top 5 most common answers for
          each question. For example, for answer #7, 4 students (67% of the
          class) answered ‘Speed’.
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={SortingProblem2}
          alt="Sorting"
        />

        <Typography className={classes.details} variant="body2">
          Note that student answers are grouped together if they character match
          each other. Case does not matter when grouping.
        </Typography>
      </div>
    </div>
  );
}
function TakeMultipleTimes() {
  const classes = useStyles();
  return (
    <div className={classes.root} style={{ maxWidth: "900px" }}>
      <div display="block">
        <Typography variant="h5" className={classes.fontHeading}>
          How students can take an assessment multiple times
        </Typography>
        <Typography className={classes.details} variant="body2">
          <span style={{ fontWeight: "700", textDecoration: "underline" }}>
            For paper assessments:
          </span>{" "}
          Print an additional answer sheet. Then scan it when the student has
          finished inputting their answers.
          <br />
          <br />
          <span style={{ fontWeight: "700", textDecoration: "underline" }}>
            For online assessments:
          </span>{" "}
          There are two ways this can be accomplished:
        </Typography>

        <Typography className={classes.details} variant="body2">
          <ol>
            <li>
              Delete the student’s result. If your assessment is still released
              to students, it will now be available for the student to take
              again.
              <br />
              <br />
            </li>

            <li>
              <Link
                className={classes.hyperlink}
                to="/help-topics/answer-sheet-topics/release-online-answer"
              >
                Un-release
              </Link>{" "}
              the assessment, and then{" "}
              <Link
                className={classes.hyperlink}
                to="/help-topics/answer-sheet-topics/release-online-answer"
              >
                Release
              </Link>{" "}
              it again.
            </li>
          </ol>
        </Typography>
      </div>
    </div>
  );
}

function ViewandSend() {
  const { path } = useRouteMatch();
  useEffect(() => {
    const script1 = document.createElement("script");
    const script2 = document.createElement("script");

    script1.src = "https://fast.wistia.com/embed/medias/khjqtsiccn.jsonp";
    script1.async = true;

    script2.src = "https://fast.wistia.com/assets/external/E-v1.js";
    script2.async = true;

    document.body.appendChild(script1);
    document.body.appendChild(script2);
  }, []);

  return (
    <>
      <Switch>
        <Route path={`${path}/walkthrough-video-results`}>
          <WalkthroughVideo />
        </Route>
        <Route path={`${path}/results-page-tips`}>
          <TipsandTricksResults />
        </Route>
        <Route path={`${path}/the-results-tab`}>
          <ResultsTab />
        </Route>
        <Route path={`${path}/the-answers-tab`}>
          <AnswersTab />
        </Route>
        <Route path={`${path}/manually-change-marks`}>
          <ManuallyChangeMarks />
        </Route>
        <Route path={`${path}/answers-flagged`}>
          <FlaggedNeedsGrading />
        </Route>
        <Route path={`${path}/filters-for-answers`}>
          <FilteringStudentResults />
        </Route>
        <Route path={`${path}/features-such-as`}>
          <FeaturesSuchAs />
        </Route>
        <Route path={`${path}/view-or-edit-results`}>
          <ViewEditResultsInfo />
        </Route>
        <Route path={`${path}/send-results`}>
          <SendResultstoStudents />
        </Route>
        <Route path={`${path}/remarking-results`}>
          <RemarkingResults />
        </Route>
        <Route path={`${path}/analysis-tab`}>
          <AnalysisTab />
        </Route>
        <Route path={`${path}/how-students-take-multiple-times`}>
          <TakeMultipleTimes />
        </Route>
      </Switch>
    </>
  );
}

export default ViewandSend;
